import React from 'react'

import {
  ListItem,
  UnorderedList,
  Text,
  ModalHeader,
  ModalContent,
  ModalBody,
  ModalOverlay,
  ModalFooter,
  Button,
  ModalCloseButton,
} from '@chakra-ui/react'
import { Spacer } from 'src/components/__legacy__/spacer/spacer'
import { WarningMessage } from 'src/components/WarningMessage/WarningMessage'
import { ApiResponse } from 'src/lib/api-client'
import { ModalCancelButton } from 'src/lib/chakra-theme/components'

type Props = {
  docs: ApiResponse<'ListICFDocumentsItem'>[]
  onClose: () => void
  onSubmit: () => void
}

export const ReAgreementConfirmModalRenewal: React.FC<Props> = ({
  docs,
  onSubmit,
}) => {
  return (
    <>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>再同意確認</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          {docs.length >= 1 ? (
            <WarningMessage
              message="以下の文書を含む同意説明に再同意が必要になります。"
              subMessage="同意説明詳細画面から再同意の実施をお願いします。"
            />
          ) : (
            <WarningMessage message="改版による文書の再同意は行いません。よろしいですか？" />
          )}
          <Spacer size={16} />
          {docs.length >= 1 && (
            <UnorderedList>
              {docs.map(doc => (
                <ListItem key={doc.uid}>
                  <Text fontWeight="bold">{doc.name}</Text>
                </ListItem>
              ))}
            </UnorderedList>
          )}
        </ModalBody>
        <ModalFooter>
          <ModalCancelButton />
          <Button onClick={onSubmit}>確定する</Button>
        </ModalFooter>
      </ModalContent>
    </>
  )
}
